import { Navigate, useParams } from 'react-router-dom';

/** Keep saved detail links working through the canonical Camadas hub. */
export function CamadaDetallePage() {
  const { camadaId = '' } = useParams<{ camadaId: string }>();
  return <Navigate to={`/camadas?camada=${encodeURIComponent(camadaId)}`} replace />;
}

export default CamadaDetallePage;
